
class UserSearchInlineSelectors {

    getComponentSelector()
    {
        return '.user_search_inline_component';
    }


    getUserSearchInlineInputSelector()
    {
        return `${this.getComponentSelector()} .user_search_inline_input`;
    }

    getUserSearchInlineButtonSelector()
    {
        return `${this.getComponentSelector()} .user_search_inline_button`;
    }

    getUserSearchInlineResultsSelector()
    {

        return `${this.getComponentSelector()} .user_search_inline_results`;
    }

    getUserSearchInlineTakeButtonSelector()
    {

        return `${this.getComponentSelector()} .user_search_inline_take_button`;
    }
}

